module.exports = __webpack_public_path__ + "media/images/lp/img_merit_03-c11933a1f9700f8e6e4ec62b182e5bed.png";